import React from 'react';

// Waveform display component
// trimStartRatio / trimEndRatio: 0–1 fractions of the full waveform array that are visible
export const WaveformDisplay = ({ waveform, width, height, color = '#10b981', trimStartRatio = 0, trimEndRatio = 1 }) => {
    if (!waveform || waveform.length === 0) return null;

    // Slice the waveform to only the visible trim region
    const startIdx = Math.floor(trimStartRatio * waveform.length);
    const endIdx = Math.ceil(trimEndRatio * waveform.length);
    const slice = waveform.slice(startIdx, endIdx);
    if (slice.length === 0) return null;

    const scaleX = width / slice.length;
    const centerY = height / 2;
    const gradientId = `waveGradient-${color.replace('#', '')}`;

    return (
        <svg width={width} height={height} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}>
            <defs>
                <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor={color} stopOpacity="0.8" />
                    <stop offset="50%" stopColor={color} stopOpacity="0.4" />
                    <stop offset="100%" stopColor={color} stopOpacity="0.8" />
                </linearGradient>
            </defs>
            <g>
                <line x1="0" y1={centerY} x2={width} y2={centerY} stroke={color} strokeWidth="0.5" opacity="0.3" />
                {slice.map((point, index) => {
                    const x = index * scaleX;
                    const maxH = Math.abs(point.max) * centerY * 0.9;
                    const minH = Math.abs(point.min) * centerY * 0.9;
                    const rmsH = point.rms * centerY * 0.7;
                    return (
                        <g key={index}>
                            <rect x={x} y={centerY - maxH} width={Math.max(1, scaleX - 0.5)} height={maxH + minH}
                                fill={`url(#${gradientId})`} opacity="0.6" />
                            <rect x={x} y={centerY - rmsH} width={Math.max(1, scaleX - 0.5)} height={rmsH * 2}
                                fill={color} opacity="0.9" />
                        </g>
                    );
                })}
            </g>
        </svg>
    );
};